module.exports = __webpack_public_path__ + "media/images/home-banners/winter-landscape-636634_1920-fc79311cb706743908480a179e31a8d3.jpg";